import { isEmpty } from 'mojito/utils';
import MojitoCore from 'mojito/core';
import MojitoPresentation from 'mojito/presentation';
import PrebuiltBets from 'modules/prebuilt-bets/index.js';
import { usePreBuiltBetCardsPromotions } from 'modules/event-cards-carousel/hooks';
import {
    usePromotions,
    usePromotionsLoadDone,
    usePromotionsPreload,
} from 'modules/promotions/hooks';
import { useLoadingStatusMetric } from 'modules/performance/hooks';
import { useMemo } from 'react';

const classUtils = MojitoCore.Base.classUtils;
const { useIrreversibleTrue } = MojitoPresentation.Hooks;

const PrebuiltPromotionCards = props => {
    const {
        applicablePage,
        mojitoTools: { config, instanceId },
        class: className,
    } = props;

    const { locationId, reportLoadingStatus } = config;

    const cardPromotions = usePromotions(locationId, applicablePage);
    const cards = usePreBuiltBetCardsPromotions(cardPromotions, config.priorityType.value);

    const promotionsLoaded = usePromotionsLoadDone();

    const [onPrepareCardsToRender, eventsLoaded, marketsLoaded] = usePromotionsPreload(
        cardPromotions,
        promotionsLoaded,
        instanceId
    );
    const betItems = useMemo(() => {
        return cards.map(card => ({
            eventId: card.content.eventId,
            marketId: card.content.marketId,
            promotionText: card.content.text,
            boostedMarketId: card.content.boostedMarketId,
        }));
    }, [cards]);
    const isContentLoaded = promotionsLoaded && eventsLoaded && marketsLoaded;
    const initialLoadDone = useIrreversibleTrue(isContentLoaded);

    const noContent = promotionsLoaded && isEmpty(betItems);
    const elementRef = useLoadingStatusMetric(
        initialLoadDone || noContent,
        reportLoadingStatus ? instanceId : undefined,
        'PrebuiltPromotionCards',
        noContent
    );
    if (noContent) {
        return null;
    }

    return (
        <PrebuiltBets
            class={classUtils.classNames('ta-PrebuiltPromotionCards', className)}
            config={config.prebuiltBets}
            betItems={betItems}
            onPrepareCardsToRender={onPrepareCardsToRender}
            isContentLoaded={initialLoadDone}
            elementRef={elementRef}
        />
    );
};

export default PrebuiltPromotionCards;
